import axios from '~/helpers/orchestration/axiosWithAuthHandling';
import { orchestration } from '~/config/public';

export const getApprovedCountries = async () => {
  const { data } = await axios.get<{ approvedCountries: { code: string }[] }>(
    `${orchestration.url}/common/approved-countries`,
    { responseType: 'json' }
  );
  return data.approvedCountries.map(({ code }) => code.toLowerCase());
};
